export const commandItemType = {
  button: 'button',
  menu: 'menu',
  menuItem: 'menuItem',
  divider: 'divider',
};
